import { Box, Flex, Divider, Text } from "@chakra-ui/react";
import Footer from "@components/Landing/Footer";
import React from "react";

export type TCmsPageContainer = {
  title: string;
  sections: TCmsPageSections[];
};
type TCmsPageSections = {
  title: string;
  content: string;
};

const CmsPageContainer = ({ title, sections }: TCmsPageContainer) => {
  return (
    <>
      <Box>
        <Flex
          px={{ base: 4, xl: 20 }}
          mt="36px"
          direction="column"
          maxWidth={"1512px"}
          margin={"auto"}
        >
          <Text
            mb={{ base: 4, lg: 12 }}
            // textStyle={{ base: "h2", lg: "h1" }}
            fontWeight={700}
            fontSize={{ base: "32px", lg: "45px" }}
            textAlign={{ base: "left", md: "center" }}
          >
            {title}
          </Text>
          <Box
            w="100%"
            gap="85px"
            justifyContent="space-between"
            textAlign="left"
          >
            <Flex mt={{ base: 8, lg: 0 }} direction={"column"}>
              {sections?.map((item) => {
                const description = item.content;
                return (
                  <Box
                    id={item.title.replaceAll(" ", "-")}
                    key={item.title.replaceAll(" ", "-")}
                  >
                    <Text fontWeight="700" fontSize="24px" lineHeight="28px">
                      {item.title}
                    </Text>
                    <Box
                      key={description}
                      mt={6}
                      fontSize={{ base: "12px", lg: "16px" }}
                      fontWeight={400}
                      color="textSecondary"
                      dangerouslySetInnerHTML={{ __html: description }}
                      sx={{
                        "& ol": {
                          pl: 4,
                        },
                        "& ul": {
                          pl: 4,
                        },
                        "& table": {
                          // border: "1px solid black",
                          display: "flex",
                          overflowX: "auto",
                        },
                        "& td": {
                          border: "1px solid black",
                          p: "4px",
                        },
                        "@media screen and (max-width: 500px)": {
                          "& figure": {
                            width: "calc(100vw - 32px)",
                            overflow: "auto",
                            maxWidth: "100%",
                          },
                        },
                      }}
                    />
                    <Divider
                      my="32px"
                      border="1px solid"
                      borderColor="#AEDFCA"
                      w="100%"
                    />
                  </Box>
                );
              })}
            </Flex>
          </Box>
        </Flex>
      </Box>
      <Footer bg="#075A5A" />
    </>
  );
};

export default CmsPageContainer;
